export default {
  title: {
    id: 'resolution_flow_resolution_option_page_out_of_warranty_title',
    defaultMessage: 'This issue may be out of warranty',
  },
  content: {
    id: 'resolution_flow_resolution_option_page_out_of_warranty_content',
    defaultMessage:
      "The warranty doesn't cover issues caused by accidental damage, exposure to water/humidity, or unauthorized third party repairs.",
  },
  link: {
    id: 'resolution_flow_resolution_option_page_out_of_warranty_link',
    defaultMessage: 'Learn about the warranty',
  },
}
